import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Icon } from '@ui/icons/Icon.tsx';

const ANIMATION_DURATION_MS = 500;
const HIDE_DELAY_MS = 500;

const MapResetButton = styled.button<{ $bearing: number }>`
  padding: 2px;
  background: rgba(0, 0, 0, 0.1);
  transform: matrix(-1, 0, 0, 1, 0, 0);
  transition-duration: ${ANIMATION_DURATION_MS}ms;
  outline: none;
  border: none;
  border-radius: 4px 0 0 4px;

  ${Icon} {
    display: inline-block;
    transform: ${({ $bearing }) => `rotate(${$bearing}deg)`};
  }
`;

const IconWrapper = styled.div`
  background: var(--color-mapNavBackground);
  border-radius: 100%;
`;

const Wrapper = styled.div`
  position: absolute;
  inset-inline-start: 0;
  top: 50%;
  transition: 0.5s ease-in-out transform;

  &.hiding {
    transform: translateX(-100%);
  }
`;

const STATE_HIDING = 'hiding';
const STATE_HIDDEN = 'hidden';
const STATE_VISIBLE = '';

type CompassViewProps = {
  resetBearingValue: number;
  onCompassClick: () => void;
  bearing: number;
};

export const CompassView = ({ resetBearingValue, onCompassClick, bearing }: CompassViewProps) => {
  const [displayState, setDisplayState] = useState<string>(STATE_HIDDEN);

  useEffect(() => {
    let timerTaskId: ReturnType<typeof setTimeout> | undefined;

    if (bearing !== resetBearingValue) {
      setDisplayState(STATE_VISIBLE);
    } else if (displayState !== STATE_HIDDEN) {
      timerTaskId = setTimeout(() => setDisplayState(STATE_HIDING), HIDE_DELAY_MS);
    }

    return () => {
      if (timerTaskId) {
        clearTimeout(timerTaskId);
      }
    };
  }, [bearing, displayState, resetBearingValue]);

  return displayState === STATE_HIDDEN ? null : (
    <Wrapper className={displayState}>
      <MapResetButton onClick={onCompassClick} $bearing={bearing}>
        <IconWrapper>
          <Icon cdn name="compass" width={30} height={30} />
        </IconWrapper>
      </MapResetButton>
    </Wrapper>
  );
};
